"use client";

import Button from "../components/Button";
import Card from "../components/Card";
import { motion } from "framer-motion";
import InvestorIcon from "../assets/icons/investor.svg";
import CalendarIcon from "../assets/icons/calendar.svg";
import SustainabilityIcon from "../assets/icons/sustainability.svg";
import ReportIcon from "../assets/icons/reportGraphic.svg";

export default function SlidingSection() {
  return (
    <section className="flex justify-center items-center min-h-screen bg-white overflow-hidden">
    <div className="container w-full flex flex-col lg:flex-row gap-8 items-center pt-6 pb-8 md:pt-0 md:pb-0">
      
      <motion.div
        className="flex-1 p-6 text-center lg:text-left"
        initial={{ x: -100, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <h1 className="capitalize text-3xl md:text-4xl mb-4">
          Investment views and <br /> financial market data
        </h1>
        <p className="mb-4 text-sm md:text-base">
          We want to create superior value for our clients, shareholders and
          employees. And we want to stand out as a winner in our industry for
          our expertise, advice and execution.
        </p>
        <Button variant="contact">Get a Demo</Button>
      </motion.div>
  
      <motion.div
        className="flex-1 p-6"
        initial={{ x: 100, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <div className="grid grid-cols-1 sm:grid-cols-2  gap-6 relative">
          <div className="flex flex-col gap-6 translate-y-[-20px]">
            <Card 
              variant="basic" 
              image={InvestorIcon} 
              title="Investor Relations"
              description="Duis aute irure dolor in velit one reprehenderit in voluptate more esse cillum dolore neris."
            />
            <Card 
              variant="basic" 
              image={SustainabilityIcon} 
              title="Sustainability"
              description="Duis aute irure dolor in velit one reprehenderit in voluptate more esse cillum dolore neris."
            />
          </div>
          <div className="flex flex-col gap-6 translate-y-[20px]">
            <Card 
              variant="basic" 
              image={CalendarIcon}
              title="Corporate Calendar"
              description="Duis aute irure dolor in velit one reprehenderit in voluptate more esse cillum dolore neris."
            />
            <Card 
              variant="basic" 
              image={ReportIcon} 
              title="Annual Reporting"
              description="Duis aute irure dolor in velit one reprehenderit in voluptate more esse cillum dolore neris."
            />
          </div>
        </div>
      </motion.div>
  
    </div>
  </section>
  
  );
}
